import { useSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';
import { useCallback, useContext } from 'react';

import { UserContext } from '~/components/providers/UserProvider';
import { AUTH_PATHS } from '~/domains/auth/consts';
import { Routes } from '~/domains/common/constants/routes';

const useRedirectAfterAuth = () => {
  const { getRedirect, clearRedirect } = useContext(UserContext);
  const router = useRouter();
  const searchParams = useSearchParams();

  const handleRedirectAfterAuth = useCallback(
    (redirectUrl?: string, useWindowLocationHref?: boolean) => {
      if (redirectUrl) {
        // EO redirect requires a `window.location.href` replacement, because `router.replace()`
        // breaks the deep link (strips the double `//` from the URL)
        if (useWindowLocationHref) {
          window.location.href = redirectUrl;
          return;
        }

        router.replace(redirectUrl);
        return;
      }

      const queryRedirect = searchParams.get('redirectTo');
      const isAuthPath = AUTH_PATHS.some((path) => queryRedirect?.match(path));
      if (queryRedirect && !isAuthPath) {
        router.push(queryRedirect as string);
        return;
      }

      const sessionRedirect = getRedirect();
      if (sessionRedirect) {
        router.push(sessionRedirect);
        clearRedirect();
        return;
      }

      router.push(Routes.main());
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [clearRedirect, getRedirect, router.push]
  );

  return handleRedirectAfterAuth;
};

export default useRedirectAfterAuth;
